import React, { Fragment } from 'react';
import { node, object } from 'prop-types';
import { FooterPersonalized } from './App.js';
import './index.scss';

export default class MPersonalizedFooter extends React.Component {
  render() {
    const { contentIdentifier } = this.props.content;
    return (
      <Fragment>
        <FooterPersonalized contentIdentifier={contentIdentifier} />
      </Fragment>
    );
  }
}

MPersonalizedFooter.propTypes = {
  children: node,
  content: object
};

MPersonalizedFooter.defaultProps = {
  children: null,
  content: {}
};
